// ACCESS-01: the grants a correct access code earns. The server asks for one on
// every call for a recipient who has a code, so they are kept per browser tab
// (sessionStorage) and sent with every request in the X-Access-Grants header.

const KEY = "accessGrants";
export const ACCESS_GRANTS_HEADER = "X-Access-Grants";
export const ACCESS_CODE_REQUIRED = "ACCESS_CODE_REQUIRED";

type Grants = Record<string, string>;

function read(): Grants {
    try {
        return JSON.parse(window.sessionStorage.getItem(KEY) || "{}");
    } catch {
        return {};
    }
}

function write(grants: Grants) {
    try {
        window.sessionStorage.setItem(KEY, JSON.stringify(grants));
    } catch {
        // storage blocked: the page asks for the code again on every load
    }
}

export function saveAccessGrant(recipientId: string, grant: string) {
    write({ ...read(), [recipientId]: grant });
}

export function hasAccessGrant(recipientId: string): boolean {
    return Boolean(read()[recipientId]);
}

export function clearAccessGrants() {
    write({});
}

// Comma separated: the server picks the grant that belongs to the recipient.
export function accessGrantsHeader(): string {
    return Object.values(read()).join(",");
}

// The server said a code is needed (the grant ran out, or the code changed): drop
// the grants and load the page again so the gate asks for it. At most once a
// minute, so a page that keeps failing cannot reload in a loop.
const RELOADED_AT = "accessGrantsReloadedAt";

export function askForTheCodeAgain() {
    clearAccessGrants();
    try {
        const last = Number(window.sessionStorage.getItem(RELOADED_AT) || 0);
        if (Date.now() - last < 60 * 1000) return;
        window.sessionStorage.setItem(RELOADED_AT, String(Date.now()));
    } catch {
        return;
    }
    window.location.reload();
}
